// returns true for IE, not for Edge
function isIE() {
    const myNav = navigator.userAgent.toLowerCase();

    return (myNav.indexOf('trident/') !== -1) ? parseInt(myNav.split('trident/')[1]) : false;
}

export { isIE };
